






















import { Component, Prop, Vue } from 'vue-property-decorator';

export interface CollectionObject {
  title: string;
  subtitle: string;
  description: string | string[];
  image: string;
}

@Component
export default class CollectionDescription extends Vue {
  @Prop({
    type: Array,
    required: true,
  })
  private items!: CollectionObject[];

  private getDescriptionOf(item: CollectionObject) {
    const desc = item.description;
    if (desc instanceof Array) {
      return desc.join(' ');
    }
    return item.description;
  }

  private getSideClasses(index: number, val: number) {
    const left = index % 2 === val;
    return {
      'left': left,
      'right': !left,
      'offset-md-1': !left,
    };
  }
}
